import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ConfigurationField from './ConfigurationField';
import SectionHeader from './SectionHeader';
import {
  SECTION_BOTTOM_MARGIN,
  SECTION_GRID_SPACING,
} from '../managedAccount.constants';

const PositivePayFileHeaderSection = ({
  form,
  fieldErrors,
  headerAccountConfigured,
  onChange,
  disabled,
}) => {
  const { t } = useTranslation();

  const getHeaderAccountTooltip = () => {
    if (headerAccountConfigured) {
      return t('managedAccounts.positivePay.fileHeader.accountSaved');
    }
    return t('managedAccounts.positivePay.fileHeader.accountRequired');
  };

  return (
    <>
      <SectionHeader>
        {t('managedAccounts.positivePay.fileHeader.title')}
      </SectionHeader>
      <Grid
        container
        spacing={SECTION_GRID_SPACING}
        sx={{ mb: SECTION_BOTTOM_MARGIN }}>
        <Grid item xs={12} md={6}>
          <ConfigurationField
            name='header_account'
            label={t('managedAccounts.positivePay.fileHeader.account')}
            value={form.header_account}
            onChange={onChange}
            error={fieldErrors.header_account}
            type='password'
            disabled={disabled}
            required={!headerAccountConfigured}
            tooltip={getHeaderAccountTooltip()}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PositivePayFileHeaderSection;
